var map = {
	"./12.jpg": 281,
	"./3.jpg": 865,
	"./9.jpg": 251,
	"./greece.jpg": 513,
	"./japan.jpg": 146,
	"./left.jpg": 351,
	"./new-york.jpg": 214,
	"./peru.jpg": 914,
	"./uruguay.jpg": 750
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 535;